import React from 'react'
import Style from '../assets/css/loader.module.css'

const Loader = () => {
    return (
        <>
            <div className={Style.rocketContainer}>
                <div className={Style.loaderTitle}>
                    <h1>Loading...</h1>
                </div>
                <div className={Style.rocket}>
                    <div className={Style.rocketBody}>
                        <div className={Style.body}></div>
                        <div className={Style.finLeft}></div>
                        <div className={Style.finRight}></div>
                        <div className={Style.window}></div>
                    </div>
                    <div className={Style.exhaustFlame}></div>
                    <ul className={Style.exhaustFumes}>
                        <li></li>
                        <li></li>
                        <li></li>
                        <li></li>
                        <li></li>
                        <li></li>
                        <li></li>
                        <li></li>
                        <li></li>
                    </ul>
                </div>
            </div>
        </>
    )
}

export default Loader
